<template>
    <div>
        <form @submit.prevent="add">
            <div class="form-row">
                <div class="form-group col-sm-6">
                    <label class="mb-1" for="phone">Телефон</label>
                    <Select2 v-model="phone_id" :options="phones" :id="'phone'" :settings="{width: '100%'}" :class="{ 'is-invalid': form.errors.has('phone') }" />
                    <has-error :form="form" field="phone"/>
                </div>
                <div class="form-group col-sm-6">
                    <label class="mb-1" for="template">Шаблон</label>
                    <Select2 v-model="template" :options="templates" :id="'template'" :settings="{width: '100%'}" :class="{ 'is-invalid': form.errors.has('template') }" />
                    <has-error :form="form" field="template"/>
                </div>
                <div class="form-group col-12">
                    <label class="mb-1" for="text">Текст</label> <CalculatorSms :text="text" />
                    <textarea class="form-control" rows="3" v-model="text" id="text" :class="{ 'is-invalid': form.errors.has('text') }" ></textarea>
                    <has-error :form="form" field="text"/>
                </div>
                <div class="form-group col-2">
                    <v-button :loading="form.busy" :large="false" :type="'primary'" >Отправить</v-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import VButton from "../../Button";
    import Form from 'vform';
    import toastr from "toastr";
    import CalculatorSms from "../../sms_templates/CalculatorSms.vue";


    export default {
        name: "AddRequestSms",
        components: {CalculatorSms, VButton},
        props: ['request'],
        data: () => ({
            phone_id: 'phone',
            template: 0,
            templates: [],
            text: '',
            template_preview: '',
            form: new Form(),
        }),
        mounted() {
            this.phone = this.request.phone;
            this.fetchTemplates();
        },
        watch: {
            template: function (val) {
                if (val) this.renderTemplate(val);
            }
        },
        computed: {
            phones: function () {
                let phones = [];
                if (this.request.phone && this.request.phone.length) phones.push({id: 'phone', text: this.$formatPhone(this.$hasPermission('request.phone.show_full.without_challenge') ? this.request.phone : this.$hidePartPhone(this.request.phone)), number: this.request.phone});
                if (this.request.phone2 && this.request.phone2.length) phones.push({id: 'phone2', text: this.$formatPhone(this.$hasPermission('request.phone.show_full.without_challenge') ? this.request.phone2 : this.$hidePartPhone(this.request.phone2)), number: this.request.phone2});
                if (this.request.phone3 && this.request.phone3.length) phones.push({id: 'phone3', text: this.$formatPhone(this.$hasPermission('request.phone.show_full.without_challenge') ? this.request.phone3 : this.$hidePartPhone(this.request.phone3)), number: this.request.phone3});
                if (this.request.phone4 && this.request.phone4.length) phones.push({id: 'phone4', text: this.$formatPhone(this.$hasPermission('request.phone.show_full.without_challenge') ? this.request.phone4 : this.$hidePartPhone(this.request.phone4)), number: this.request.phone4});
                if (this.request.phone5 && this.request.phone5.length) phones.push({id: 'phone5', text: this.$formatPhone(this.$hasPermission('request.phone.show_full.without_challenge') ? this.request.phone5 : this.$hidePartPhone(this.request.phone5)), number: this.request.phone5});
                if (this.request.phone6 && this.request.phone6.length) phones.push({id: 'phone6', text: this.$formatPhone(this.$hasPermission('request.phone.show_full.without_challenge') ? this.request.phone6 : this.$hidePartPhone(this.request.phone6)), number: this.request.phone6});
                return phones;
            }
        },
        methods: {
            async add () {
                if (this.validate()) {
                    console.log(_.find(this.phones, {id: this.phone_id}).number, this.phones, this.phone_id);
                    this.form.request_id = this.request.id;
                    this.form.text = this.text;
                    this.form.phone = _.find(this.phones, {id: this.phone_id}).number;

                    const {data} = await this.form.post('/api/request_sms_messages');
                    this.text = '';
                    toastr.success('Отправлена СМС');
                    this.$bus.$emit('request.' + this.request.id + '.sms_message:create');
                }
            },
            validate: function () {
                this.form = new Form();
                if (this.text.length <= 0) {
                    this.form.errors.set('text', ['Текст не может быть пустым']);
                    return false;
                }
                if (!this.phone || this.phone.length <= 0) {
                    this.form.errors.set('phone', ['Выберите телефон']);
                    return false;
                }
                return  true;
            },
            fetchTemplates() {
                let self = this;
                axios.get('/api/request_sms_templates')
                    .then(function (response) {
                        let temps = [];
                        temps.push({id: 0, text: 'Выберите шаблон', disabled: true});
                        response.data.forEach(function (item) {
                            if (self.request.platform_id === item.platform_id) {
                                temps.push({id: item.id, text: item.name})
                            }
                        });
                        self.templates = temps;
                    })
            },
            renderTemplate(id) {
                let self = this;
                axios.get('/api/request_sms_templates/' + id + '/render', {params: {request_id: this.request.id}})
                    .then(function (response) {
                        self.text = response.data;
                    })
            }
        }
    }
</script>

<style scoped>

</style>
